import { render, staticRenderFns } from "./Pelleter.vue?vue&type=template&id=cf9f4320&"
import script from "./Pelleter.vue?vue&type=script&lang=js&"
export * from "./Pelleter.vue?vue&type=script&lang=js&"
import style0 from "./Pelleter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports